import { Component, Input, OnInit } from '@angular/core';
import { EditedUser, TinAccess } from '../manage-access.model';

import isEqual from 'lodash/isEqual';
import differenceBy from 'lodash/differenceBy';
import intersectionBy from 'lodash/intersectionBy';

@Component({
  selector: 'cigna-user-access-diff',
  templateUrl: './user-access-diff.component.html',
  styleUrls: ['./user-access-diff.component.css'],
})
export class UserAccessDiffComponent implements OnInit {
  @Input() user: EditedUser;
  @Input() userType: string;
  @Input() isVendorSuccess: boolean;

  @Input()
  get unChangedTins() {
    return this._noChanges;
  }

  @Input()
  get changedTins() {
    return this._changes;
  }

  _noChanges: TinAccess[] = [];
  _changes: any[] = [];

  ngOnInit() {
    // dont do anything if we dont have neccessary inputs
    if (!this.user || !this.user.accessBefore || !this.user.accessAfter) {
      return null;
    }

    const accessBefore: TinAccess[] = this.user.accessBefore;
    const accessAfter: TinAccess[] = this.user.accessAfter;

    this._noChanges = [];
    this._changes = [];

    accessBefore.forEach((beforeTin) => {
      const matchingTin = accessAfter.find(
        (afterTin) => afterTin.tin === beforeTin.tin,
      );
      if (matchingTin) {
        if (isEqual(matchingTin.entitlements, beforeTin.entitlements)) {
          this._noChanges.push(beforeTin);
        }
      } else {
        this._noChanges.push(beforeTin);
      }
    });

    this._changes = accessAfter
      .filter(
        (afterTin) =>
          this._noChanges.findIndex(
            (unchangedTin) => unchangedTin.tin === afterTin.tin,
          ) === -1,
      )
      .map((afterTin) => {
        const beforeTin = accessBefore.find(
          (bTin) => bTin.tin === afterTin.tin,
        );
        const beforeEntitlements =
          beforeTin && beforeTin.entitlements ? beforeTin.entitlements : [];
        const afterEntitlements = afterTin.entitlements
          ? afterTin.entitlements
          : [];
        return {
          tin: afterTin.tin,
          name: afterTin.name,
          status: afterTin.status,
          diff: this.diffTwoArraysOfObjects(
            beforeEntitlements,
            afterEntitlements,
            'id',
          ),
        };
      });
  }

  diffTwoArraysOfObjects = (before: any[], after: any[], key: string) => ({
    same: this.areEntitlementsSame(before, after, key),
    added: differenceBy(after, before, key),
    removed: differenceBy(before, after, key),
  });

  // to identify the scenarios where entitlements are unchanged but functions are modified
  areEntitlementsSame(array1: any[], array2: any[], key: string) {
    return array1
      .filter((a1) => array2.some((a2) => a2[key] === a1[key]))
      .map((a1) => {
        const matchedData = array2.find((a2) => a2[key] === a1[key]);
        if (matchedData.functions?.length || a1.functions?.length) {
          return {
            ...a1,
            updatedFunctions: {
              same: intersectionBy(matchedData.functions, a1.functions, 'name'),
              added: differenceBy(matchedData.functions, a1.functions, 'name'),
              removed: differenceBy(
                a1.functions,
                matchedData.functions,
                'name',
              ),
            },
          };
        }
        return a1;
      });
  }
}
